var render, staticRenderFns
import script from "./WordCloudSampleView.vue?vue&type=script&lang=js"
export * from "./WordCloudSampleView.vue?vue&type=script&lang=js"
import style0 from "./WordCloudSampleView.vue?vue&type=style&index=0&id=79f091da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f091da",
  null
  
)

export default component.exports